export const ERROR_TRANSLATION_CODES = {
    ALREADY_SCHEDULED: "already-scheduled",
    SLOT_BOOKING_EXISTS: "slot-booking-exists",
    ALREADY_BOOKING_SALES_ORDER: "already-booking-for-salesorder",
};
